import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import type {
  TComboboxSeparatorElement,
  TComboboxSeparatorProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { cn } from "@/ui/lib/utils";

export const ComboboxSeparator = forwardRef<TComboboxSeparatorElement, TComboboxSeparatorProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <CommandPrimitive.Separator
      data-component="ComboboxSeparator"
      ref={ref}
      className={cn("-mx-1 h-px bg-component-input-default", className)}
      {...props}
    />
  ),
);

ComboboxSeparator.displayName = CommandPrimitive.Separator.displayName;
